// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TransferIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M12.89 18.31c0-1.48 1.2-2.68 2.68-2.68H16q.2-.02.23-.22c.04-.61.3-1.21.77-1.68 1.05-1.05 2.75-1.05 3.8 0l.85.85c.13.13.36.04.36-.15.08-2.13 0-4.3 0-6.43 0-3.44-2.36-6.02-5.47-6.02H6.98C3.86 1.98 1.5 4.56 1.5 8v6.66c0 1.72.64 3.33 1.72 4.4.97.97 2.36 1.5 3.76 1.5h6.41c.22 0 .32-.3.18-.47-.43-.47-.68-1.1-.68-1.78"
        opacity=".5"
      />
      <path d="m9.88 12.4-4.4-3.54c-.33-.32-.44-.75-.11-1.18.32-.33.75-.43 1.18-.11l4.4 3.54c.54.43 1.3.43 1.83 0l4.3-3.54c.32-.32.86-.22 1.18.1.1.33.1.87-.22 1.19l-4.3 3.54c-.53.43-1.28.65-1.93.65q-.96 0-1.93-.65m12.38 5.45-2.79-2.8c-.31-.3-.82-.3-1.14 0-.31.32-.31.83 0 1.15l1.31 1.3h-4.2c-.45 0-.81.37-.81.81s.36.8.8.8h4.43l-1.53 1.53c-.31.32-.31.83 0 1.14q.25.24.57.24t.57-.24l2.8-2.8c.3-.3.3-.82 0-1.13" />
    </g>
  </SvgIcon>
);

export default TransferIcon;
